export default "__VITE_ASSET__9OH987wS__"